import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import EmailIcon from '@material-ui/icons/Email';

import ContactForm from '../ContactForm';
import HideOnScroll from './HideOnScroll';
import DeviceMenu from './DeviceMenu';
import I18n from '../I18n';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginBottom: theme.spacing(8),
		[theme.breakpoints.down('xs')]: {
			marginBottom: theme.spacing(7)
		}
	},
	title: {
		display: 'flex',
		flexGrow: 1
	},
	space: {
		marginRight: theme.spacing(2)
	},
	logo: {
		height: '40px',
		marginTop: '6px',
		[theme.breakpoints.down('xs')]: {
			display: 'none'
		}
	},
	logoSm: {
		display: 'none',
		height: '40px',
		marginTop: '5px',
		[theme.breakpoints.down('xs')]: {
			display: 'inline-block'
		}
	}
}));

const Navbar = () => {
	const classes = useStyles();

	// const [formOpen, setFormOpen] = useState(false);

	/*
	const openForm = () => {
		setFormOpen(true);
	};

	const closeForm = () => {
		setFormOpen(false);
	};
	*/
  	return (
	    <div className={classes.root}>
	      <HideOnScroll>
	        <AppBar>
	          <Toolbar>
	            <div className={classes.title}>
	              <Link to='/'>
	                <img
	                  className={classes.logo}
	                  src='/logos/logo-ecordum-white.svg'
	                  alt='ecordum logo'
	                />
	                <img
	                  className={classes.logoSm}
	                  src='/logos/logo-white.svg'
	                  alt='ecordum logo'
	                />
	              </Link>
	            </div>
	            <Button className={classes.space}>
					<a target='_blank' rel='noopener noreferrer' style = {{color:'#fff', textDecoration:'none'}} href='https://r.ecordum.cn:7443/corecarepro/index.html'>
						{I18n('setting.login')}
					</a>
				</Button>
	            <DeviceMenu className={classes.space} />
	          </Toolbar>
	        </AppBar>
	      </HideOnScroll>
	    </div>
  	);
};

export default Navbar;
